import { Pipe, PipeTransform } from "@angular/core";
import { BytesPacketsFormatterService } from "../services/util/bytes-packets-formatter.service";

/**
 * Pipe para formatar bytes em k, M, G, T, or P.
 */
@Pipe({
    name: "bytesFormatter"
})
export class BytesFormatterPipe implements PipeTransform {

    constructor(private readonly bytesPacketsFormatterService: BytesPacketsFormatterService) {
    }

    transform(bytes: number): string {
        const bpsUnits = ["bps", "kbps", "Mbps", "Gbps", "Tbps", "Pbps"];
        return this.bytesPacketsFormatterService.format(bytes, bpsUnits);
    }
}
